import React from 'react';

import { ResponsivePaymentsTable } from './PaymentsOverviewTable.component';
import { outstandingPaymentsDesktopColumns } from './PaymentsOverviewTable.declaration-desktop';
import { paymentsOverviewMobileColumns } from './PaymentsOverviewTable.declaration-mobile';
import { Box, Typography } from '@mui/material';
import { PatientServiceItem } from '@uplift/api';


export const OutstandingPaymentsTable: React.VFC<{
  items: PatientServiceItem[];
}> = ({ items: outstandingServiceItems }) => {
  if (!outstandingServiceItems.length) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Box px={{ xs: 2, sm: 0 }}>
        <Typography variant="h4">Outstanding ({outstandingServiceItems.length})</Typography>
      </Box>
      <ResponsivePaymentsTable
        columns={{
          desktop: outstandingPaymentsDesktopColumns,
          mobile: paymentsOverviewMobileColumns,
        }}
        rows={outstandingServiceItems}
      />
    </Box>
  );
};
